import React from 'react';
import cx from 'classnames';

import { CtaFieldType, ImageFieldType } from 'libs/contentful/types';

import SponsorModule from '../SponsorModule';
import MarkdownWrapper from '../MarkdownWrapper';

import styles from './ArticleBody.module.less';

type ArticleBodyProps = {
  contentMD: string;
  sponsorCta?: CtaFieldType;
  sponsorName?: string;
  sponsorAbout?: string;
  sponsoredBottomContent?: string;
  sponsorLogoImage?: ImageFieldType;
};

const ArticleBody: React.FC<ArticleBodyProps> = ({
  contentMD,
  sponsorCta,
  sponsorName,
  sponsorAbout,
  sponsoredBottomContent,
  sponsorLogoImage,
}) => {
  const SponsoredArticleBody = () => (
    <React.Fragment>
      <MarkdownWrapper source={contentMD} styleOverride={styles.sponsoredBodyMarkdown} />
      <div className={cx(styles.sponsoredContainer, styles.sponsoredBodyContainer)}>
        <MarkdownWrapper source={sponsoredBottomContent} />
      </div>
      <div className={styles.sponsoredAboutContainer}>
        <SponsorModule
          sponsorCta={sponsorCta}
          sponsorName={sponsorName}
          sponsorAbout={sponsorAbout}
          sponsorLogoImage={sponsorLogoImage}
        />
      </div>
    </React.Fragment>
  );

  return (
    <section>
      <div className={styles.container}>
        {sponsoredBottomContent ? <SponsoredArticleBody /> : <MarkdownWrapper source={contentMD} />}
      </div>
    </section>
  );
};

export default ArticleBody;
